// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3071":"d92cfe19","8017":"a234f0e3"}[chunkId] + ".chunk.css";
};